module.exports = __webpack_public_path__ + "static/apps@2x-4f5726afb22d2a76eadc973f937118a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/apps/apps@2x.jpg
// module id = 2538
// module chunks = 180189194464636